module.exports = __webpack_public_path__ + "img/img4.1aa029ba.png";